import api from './api';

/**
 * Bulk Photo Edit (Photo Studio) API.
 * The shared `api` instance unwraps to the response body ({ success, message, data }).
 */
const bulkPhotoService = {
    // Client-safe style presets + per-image credit cost
    getThemes: () => api.get('/api/bulk-photo/themes'),

    // List projects (+ images) for the active office space. Also resumes pending
    // work server-side. Pass { officeSpaceId } to scope to a single space.
    list: (params = {}) => api.get('/api/bulk-photo/projects', { params }),

    // One project (+ images)
    get: (id) => api.get(`/api/bulk-photo/projects/${id}`),

    // Multipart create/append → queue images, start processing
    create: (formData) =>
        api.post('/api/bulk-photo/projects', formData, { timeout: 300000 }),

    // Pause / resume
    setPaused: (id, paused) => api.patch(`/api/bulk-photo/projects/${id}`, { paused }),

    deleteProject: (id) => api.delete(`/api/bulk-photo/projects/${id}`),
    deleteImage: (id) => api.delete(`/api/bulk-photo/images/${id}`),

    // Rename a project / a single image
    renameProject: (id, name) => api.patch(`/api/bulk-photo/projects/${id}/name`, { name }),
    renameImage: (id, name) => api.patch(`/api/bulk-photo/images/${id}`, { name }),

    // Re-run the AI edit for one image (optionally with a new theme)
    regenerateImage: (id, theme = null) =>
        api.post(`/api/bulk-photo/images/${id}/regenerate`, theme ? { theme } : {}),

    // Download a single image via the backend proxy (avoids R2 CORS). Returns a Blob.
    downloadImage: (id, type = 'enhanced') =>
        api.get(`/api/bulk-photo/images/${id}/download`, { params: { type }, responseType: 'blob' }),
};

export default bulkPhotoService;
